import React from 'react';
import classnames from 'classnames';

import * as styles from './content.module.scss';
import './custom-blocks.scss';

const Content = ({ data, contentHead }) => {
  return (
    <section className={classnames(styles.section)}>
      <div className={classnames(styles.head)}>
        <h1 className={classnames(styles.title)}>{contentHead.title}</h1>

        {contentHead.excerpt ? (
          <div
            className={classnames('scr-lead')}
            dangerouslySetInnerHTML={{ __html: contentHead.excerpt }}
          ></div>
        ) : null}
      </div>

      <article
        className={classnames(styles.article)}
        dangerouslySetInnerHTML={{ __html: data }}
      ></article>
    </section>
  );
};

export default Content;
